import styled from 'styled-components'

export const HighlightGraphic = styled.div`
  position: absolute;
  display: inline;
  top: -12px;

  svg {
    color: ${({ theme }) => theme.colourPalette?.primaryColour || 'var(--brand-primary)'};
  }
`
export const UnderlineGraphic = styled.div<{ bottomOffset?: string }>`
  position: absolute;
  bottom: ${(props) => props.bottomOffset ?? '-16px'};
  left: 0;
`

export const ShineGraphic = styled.div`
  position: absolute;
  display: inline;
  top: -25px;
  right: -50px;
  width: min-content;
`
